/**
 * Temporary dual-name support while the API may return `referral` or `in-person-visit` as the modality type string.
 */
export const IN_PERSON_VISIT_OPTION_TYPE = 'in-person-visit' as const

type InPersonModalityLiteral = 'referral' | typeof IN_PERSON_VISIT_OPTION_TYPE

export function isInPersonModality(type: string | undefined | null): type is InPersonModalityLiteral {
    return type === 'referral' || type === IN_PERSON_VISIT_OPTION_TYPE
}

type InPersonVisitType = 'Referral' | 'InPersonVisit'

export function isInPersonVisitType(type: string | undefined | null): type is InPersonVisitType {
    return type === 'Referral' || type === 'InPersonVisit'
}

/** Dashboard / My Care visit type for Solv urgent care orders. */
export const URGENT_CARE_VISIT_TYPE = 'UrgentCare' as const

export function isUrgentCareVisitType(type: string | undefined | null): type is typeof URGENT_CARE_VISIT_TYPE {
    return type === URGENT_CARE_VISIT_TYPE
}